import { AuditoriumDetails } from '@/modals/auditorium/auditorium-details';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import SwiperCore, { Navigation, Pagination, SwiperOptions, Scrollbar, Autoplay } from 'swiper';
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);

@Component({
  selector: "app-auditorium-upload",
  templateUrl: "./auditorium-upload.component.html",
  styleUrls: ["./auditorium-upload.component.scss"],
})
export class AuditoriumUploadComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  // model
  auditoriumModel: boolean = false;
  auditoriumDetails: AuditoriumDetails[] = [];
  websiteName: string = "";
  websiteId: number = 0;
  submitted: boolean = false;
  fileTouched: boolean = false;
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    private spinner: NgxSpinnerService,
    protected configService: ConfigService
  ) {}

  isEdit = false;

  ngOnInit() {
    this.websiteName = localStorage.getItem("selectedWebsiteName");
    this.websiteId = Number(localStorage.getItem("selectedWebsiteId"));
    this.loadAuditoriums();
  }

  auditoriumForm = new UntypedFormGroup({
    auditoriumSeq: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    schoolName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    location: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    description: new UntypedFormControl(""),
    websiteId: new UntypedFormControl(0, [
      Validators.required,
      Validators.nullValidator,
    ]),
    websiteName: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
    base64Code: new UntypedFormControl(""),
    fileType: new UntypedFormControl(""),
    filePath: new UntypedFormControl(""),
    status: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator,
    ]),
  });

  public auditoriumFormErrors = {
    schoolName: "",
    location: "",
    filePath: "",
  };

  loadAuditoriums() {
    // fetch existing auditorium list from API
    this.spinner.show();
    this.appService
      .getAllAuditoriumDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          console.log("all-Auditorium", data);
          this.spinner.hide();
          this.auditoriumDetails = data.sort(
            (a, b) => b.auditoriumSeq - a.auditoriumSeq
          );
        },
        (error: any) => {
          this.spinner.hide();
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }

  toggleStatus(item: any, event: any) {
     
   if(event.target.checked) {
    const payload = {
      auditoriumSeq:item,
      status: 'Active'
    }
     this.updateStatus(payload)
    console.log("checked or Active",payload )
   } else {
     const payload = {
      auditoriumSeq:item,
      status: 'InActive'
    }
    this.updateStatus(payload)
    console.log("Un-checked or Inactive",payload )
   }
  }

  updateStatus(payload) {
    this.spinner.show();
    this.appService
      .updateAuditoriumStatus(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          console.log("status", data);
          this.spinner.hide()
         this.toastr.success (" Status Updated successfully");
        },
        (error: any) => {
          this.spinner.hide();
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }

  onSubmit() {
    this.formValidation();
  }

  formValidation(): void {
    this.auditoriumForm.controls["websiteId"].setValue(this.websiteId);
    this.auditoriumForm.controls["websiteName"].setValue(this.websiteName);
    this.submitted = true;

    // Reset errors
    this.auditoriumFormErrors = {
      schoolName: "",
      location: "",
      filePath: "",
    };

    let hasError = false;

    if (!this.auditoriumForm.get("schoolName")?.value) {
      this.auditoriumFormErrors.schoolName = "*School Name is required";
      hasError = true;
    }

    if (!this.auditoriumForm.get("location")?.value) {
      this.auditoriumFormErrors.location = "*Location is required";
      hasError = true;
    }

    if (!hasError) {
      if (this.isEdit) {
        this.updateAuditoriumDetails();
      } else {
        this.saveAuditoriumDetails();
      }
    }
  }

  configCity: SwiperOptions = {
  slidesPerView: 4,
  spaceBetween: 20,
  autoplay: false,
  loop: false,
  navigation: true,
  pagination: { clickable: true },
  grid: {
    rows: 2,
    fill: 'row', // fill slides by row
  },
  breakpoints: {
    1200: { slidesPerView: 4 },
    992: { slidesPerView: 3 },
    768: { slidesPerView: 2 },
    0: { slidesPerView: 1 },
  },
};


  onFileSelected(event: Event): void {
    this.fileTouched = true;
    const input = event.target as HTMLInputElement;

    if (input?.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only PNG, JPG, and JPEG image files are allowed.");
        this.auditoriumForm.patchValue({ filePath: "" });
        return;
      }

      // If image size > 2MB, compress
      if (file.size > 2 * 1024 * 1024) {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const MAX_WIDTH = 1000;
            const scale = MAX_WIDTH / img.width;
            canvas.width = MAX_WIDTH;
            canvas.height = img.height * scale;

            const ctx = canvas.getContext("2d");
            ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Compress and convert to base64
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  const compressedReader = new FileReader();
                  compressedReader.onloadend = () => {
                    const fullBase64 = reader.result as string;
                    const base64 = fullBase64.split(",")[1];
                    this.auditoriumForm.patchValue({
                      base64Code: base64,
                      fileType: file.type,
                      filePath: file.name,
                    });
                  };
                  compressedReader.readAsDataURL(blob);
                }
              },
              file.type,
              0.7 // Compression quality
            );
          };
          img.src = reader.result as string;
        };
        reader.readAsDataURL(file);
      } else {
        // File under 2MB, no compression needed
        const reader = new FileReader();
        reader.onload = () => {
          const fullBase64 = reader.result as string;
          const base64 = fullBase64.split(",")[1];
          this.auditoriumForm.patchValue({
            base64Code: base64,
            fileType: file.type,
            filePath: file.name,
          });
        };
        reader.readAsDataURL(file);
      }
    } else {
      this.auditoriumForm.patchValue({ filePath: "" });
    }
  }

  saveAuditoriumDetails() {
    this.spinner.show();
    this.appService
      .saveAuditoriumDetails(this.auditoriumForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toastr.success(
            data.schoolName + " details saved successfully..."
          );
          this.auditoriumModel = false;
          this.submitted = false;
          this.fileTouched = false;
          this.auditoriumForm.reset();
          if (this.fileInput) {
            this.fileInput.nativeElement.value = "";
          }
          this.auditoriumForm.patchValue({
            base64Code: "",
            fileType: "",
            filePath: "",
          });
          this.loadAuditoriums();
        },
        (error: any) => {
          this.spinner.hide();
          this.auditoriumModel = false;
          this.submitted = false;
          this.fileTouched = false;
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }

  updateAuditoriumDetails() {
    const auditoriumSeq = this.auditoriumForm.get("auditoriumSeq").value;
    this.spinner.show();
    this.appService
      .updateAuditoriumDetails(auditoriumSeq, this.auditoriumForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toastr.success(
            data.schoolName + " details updates successfully..."
          );
          this.auditoriumModel = false;
          this.submitted = false;
          this.fileTouched = false;
          this.isEdit = false;
          this.auditoriumForm.reset();
          if (this.fileInput) {
            this.fileInput.nativeElement.value = "";
          }
          this.auditoriumForm.patchValue({
            base64Code: "",
            fileType: "",
            filePath: "",
          });
          this.loadAuditoriums();
        },
        (error: any) => {
          this.spinner.hide();
          this.auditoriumModel = false;
          this.submitted = false;
          this.fileTouched = false;
          this.isEdit = false;
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }

  editAuditorium(item: any) {
    this.isEdit = true;
    this.auditoriumModel = true;
    this.auditoriumForm.patchValue(item);
  }

  deleteAuditorium(item: any) {
    this.spinner.show();
    this.appService
      .deleteAuditoriumById(item.auditoriumSeq)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toastr.success(
            item.schoolName + " details delete successfully..."
          );
          this.loadAuditoriums();
        },
        (error: any) => {
          this.spinner.hide();
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = "https://a-a.lighting/assets/img/AALighting.png";
  }

  close() {
    this.isEdit = true;
    this.auditoriumModel = false;
    this.submitted = false;
    this.fileTouched = false;
    this.auditoriumForm.reset();
  }

  clearFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = ""; // Clear the actual file input element
    this.auditoriumForm.patchValue({
      base64Code: "",
      fileType: "",
      filePath: "",
    });
    this.fileTouched = false; // Reset touched state if you track it
  }
}
